<template>
    <div class="nav-panel-content grid grid__base" :class="bemFacets">
        <template v-for="(item, idx) in items">
            <accordion-item class="nav-panel-content--item"
                    v-if="item.items && item.items.length > 0"
                    :facets="['mobile-nav', isActiveFacet(item)]"
                    :key="idx"
                    :label="item.label"
                    :is-open="isAccordionOpen(item, idx)"
                    @open="onOpen(idx)"
                    @close="onClose"
            >
                <base-icon symbol="chevron-down" size="large" slot="icon"/>
                <div class="nav-panel-content--child-wrapper">
                    <navigation-entry
                            class="nav-panel-content--child"
                            v-for="(child, cIdx) in item.items"
                            :facets="['mobile-nav']"
                            :key="cIdx"
                            v-bind="child"/>
                </div>

                <a class="nav-panel-content--overview-btn btn btn__primary-green btn__has-grid btn__medium"
                        v-if="item.show_all_label"
                        :href="item.path"
                >
                    {{ item.show_all_label }}
                </a>
            </accordion-item>

            <div class="nav-panel-content--item nav-panel-content--direct-link" v-else :key="idx">
                <div class="nav-panel-content--container grid--container">
                    <a class="u-reset nav-panel-content--item-link" :class="directLinkActive(item)" :href="item.path">
                        {{ item.label }}
                    </a>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import AccordionItem from 'framework/global-components/dyn/accordion-item/accordion-item';
    import NavigationEntry from 'framework/components/navigation/navigation-entry/navigation-entry';

    import bemMixin from 'framework/mixins/bem/index';

    export default {
        components: { NavigationEntry, AccordionItem },
        mixins: [bemMixin('nav-panel-content')],
        props: {
            /** @type {INavigationEntry[]} */
            items: {
                type: Array,
                required: true,
            },
        },

        data() {
            return {
                currentOpenIdx: null,
            };
        },

        methods: {
            /**
             * Check if the item should be marker as active
             * @param {INavigationEntry} item
             * @return {string}
             */
            isActiveFacet(item) {
                return item.is_active ? 'active' : null;
            },

            /**
             * Check if the direct link should be marker as active
             * @param {INavigationEntry} item
             * @return {string}
             */
            directLinkActive(item) {
                return item.is_active ? this.bemAdd('active', 'item-link') : null;
            },

            /**
             * Check if the accordion item should be open
             * @param {INavigationEntry} item
             * @param {number} idx
             * @return {string}
             */
            isAccordionOpen(item, idx) {
                return this.currentOpenIdx === idx || (this.currentOpenIdx === null && item.has_active_children);
            },

            onClose() {
                this.currentOpenIdx = false;
            },

            onOpen(idx) {
                this.currentOpenIdx = idx;
            },
        },
    };
</script>
